var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 44,
    viewBox: "0 0 48 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.53358 40.077L12.9577 29.1855C10.0203 25.9848 8.41094 21.9575 8.41094 17.765C8.41094 7.96953 17.105 0 27.7909 0C38.4769 0 47.1709 7.96953 47.1709 17.765C47.1709 27.5604 38.4769 35.53 27.7909 35.53C23.7793 35.53 19.9564 34.4208 16.6879 32.3153L5.17702 43.2894C4.69589 43.7474 4.04876 44 3.3553 44C2.69891 44 2.07622 43.7706 1.60352 43.3535C0.599129 42.4676 0.567108 40.9985 1.53358 40.077ZM27.7909 4.63434C19.8923 4.63434 13.4666 10.5246 13.4666 17.765C13.4666 25.0054 19.8923 30.8956 27.7909 30.8956C35.6895 30.8956 42.1153 25.0054 42.1153 17.765C42.1153 10.5246 35.6895 4.63434 27.7909 4.63434Z",
    fill: "#D6D6D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e36527a524b5342be9867b09d36af8c6.svg";
export { ForwardRef as ReactComponent };